import React from 'react';
import { ShimmerCircularImage, ShimmerTitle, ShimmerThumbnail } from "react-shimmer-effects";
import LikeFooterLoader from './LikeFooterLoader';

const ObservationDetailsLoader: React.FC<{showFooter?: boolean}> = ({showFooter = true}) => {
  return (
    <>
      <div className='d-flex align-items-center'>
        <div className="d-flex align-items-center flex-1">
          <ShimmerCircularImage size={30} className="flex-1 mg-b-0" />
          <div style={{ width: '130px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" /></div>
        </div>
        <div style={{ width: '50px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
      </div>
      <div className="mg-t-10 d-flex flex-wrap mx-n-4">
        <div className="pd-x-4 col-2"><ShimmerThumbnail height={24} className="rounded-3 mb-0" /></div>
        <div className="pd-x-4 col-3"><ShimmerThumbnail height={24} className="rounded-3 mb-0" /></div>
        <div className="pd-x-4 col-2"><ShimmerThumbnail height={24} className="rounded-3 mb-0" /></div>
        <div className="pd-x-4 col-4"><ShimmerThumbnail height={24} className="rounded-3 mb-0" /></div>
        <div className="pd-x-4 col-3"><ShimmerThumbnail height={24} className="rounded-3 mb-0" /></div>
        <div className="pd-x-4 col-2"><ShimmerThumbnail height={24} className="rounded-3 mb-0" /></div>
      </div>
      <div className="mg-t-8 d-flex flex-wrap mx-n-4">
        <div className="pd-x-4 w-50"><ShimmerThumbnail height={178} className="rounded-3 mb-0" /></div>
        <div className="pd-x-4 w-50"><ShimmerThumbnail height={178} className="rounded-3 mb-0" /></div>
        <div className="pd-x-4 col-4"><ShimmerThumbnail height={114} className="rounded-3 mb-0" /></div>
        <div className="pd-x-4 col-4"><ShimmerThumbnail height={114} className="rounded-3 mb-0" /></div>
        <div className="pd-x-4 col-4"><ShimmerThumbnail height={114} className="rounded-3 mb-0" /></div>
      </div>
      <ShimmerTitle line={6} gap={5} variant="primary" className="mg-t-12 mg-b-0" />

      {showFooter && <div className='like-comment-footer'>
        <LikeFooterLoader />
      </div>}
    </>
  );
};

export default ObservationDetailsLoader;
